<div class="parent">
  <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="changeTab($event)">
    <mat-tab *ngFor="let tab of tabsTaskListConfigs">
      <ng-template mat-tab-label>
        <span>{{ tab.name }}</span>
        <ng-container *ngTemplateOutlet="counter; context: { tab }"></ng-container>
      </ng-template>
      <div class="sub-tabs">
        <ng-container *ngFor="let subTab of tab.children">
          <div
            [ngClass]="{ selected: taskListConfiguration.queueId === subTab.queueId }"
            class="sub-tab clickable"
            (click)="changeSubTab(subTab.queueId)">
            <span>{{ subTab.name }}</span>
            <ng-container *ngTemplateOutlet="counter; context: { tab: subTab }"></ng-container>
          </div>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #counter let-tab="tab">
  <!-- tab.counterIndex !== undefined is for excluded tabs -->
  <ng-container *ngIf="tab.counterIndex !== undefined">
    <!-- tab.counter !== undefined is for getCountersCallback in ngOnInit, to prevent broken display -->
    <!-- counters.length is for waiting counters to be loaded -->
    <span>
      <ng-container *ngIf="tab.counter !== undefined && counters.length; else loading">
        <ng-container *ngFor="let counter of tab.counter; index as i">
          <span
            *ngIf="tab.counterTooltip; else noTooltip"
            class="counter"
            [innerHTML]="counter | truncateCounter"
            [matTooltip]="tab.counterTooltip[i]"></span>
          <ng-template #noTooltip>
            <span class="counter" [innerHTML]="counter | truncateCounter"></span>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #loading><span class="counter">...</span></ng-template>
    </span>
  </ng-container>
</ng-template>
